import { FolderArrowUpDownOutlineIcon } from './FolderArrowUpDownOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 0D1FD0C5-6A2C-475F-8824-A1EC1B93E85F
 * name folder-arrow-up-down-outline
 * version: 6.6.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/folder-arrow-up-down-outline.svg
 * tags
 * - Files / Folders 
 */
export const FolderTransferOutlineIcon = FolderArrowUpDownOutlineIcon;
export default FolderTransferOutlineIcon